import React, { FC, useContext, useEffect, useMemo, useState } from 'react';
import st from './mapLayout.module.scss'
import cn from 'classnames'
import {useLocation} from "react-router-dom";
import MapContainer from "../../modules/map/MapContainer";
import {IconBox, Type as T} from "@infobis/ui-styles-utils";
import { useTypedSelector } from "@hooks/useTypedSelector";
import { ApplicationContext } from "@pages/monitoring/map/MapPage";
import Logger from "@utils/logger";

interface MapLayout {
  children?: React.ReactNode
}

const log = Logger.getLogger("map.layout")

const MapLayout: FC<MapLayout> = (props) => {
  
  let {
    children,
  } = props
  
  let [isShowMenu, setIsShowMenu] = useState<boolean>(true)
  const applicationContext = useContext(ApplicationContext)
  useEffect(() => {
    if(applicationContext?.pixiContext)
      applicationContext?.pixiContext.map.invalidateSize({pan: false})
  }, [isShowMenu, applicationContext])

  return (
    <div className={cn(st.container)}>
      
      <section className={cn(st.card, isShowMenu ? st.card_active : st.card_disable,)}>
        {children}
        <div className={cn(st.card_control)} onClick={() => setIsShowMenu(i => !i)}>
          {isShowMenu ?
            <IconBox
              icon={T.IconName.ChevronLeft}
            /> :
            <IconBox
              icon={T.IconName.ChevronRight}
            />
          }
        </div>
      </section>
      <section className={cn(st.map)}>
        <MapContainer
          activeArea={{width: "100%"}}
        />
      </section>
    </div>
  )
  
  
}
export default MapLayout;